import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from './text.module.scss';
var cn = classNames.bind(style);
var BLOCK_NAME = 'Text';
var TextComponent = function (_a) {
    var _b;
    var _c = _a.color, color = _c === void 0 ? 'black' : _c, isUpperCase = _a.isUpperCase, _d = _a.size, size = _d === void 0 ? 'h4' : _d, _e = _a.tagType, Tag = _e === void 0 ? 'span' : _e, text = _a.text, isEllipsis = _a.isEllipsis, whiteSpace = _a.whiteSpace, title = _a.title, textRef = _a.textRef;
    return (React.createElement(Tag, { ref: textRef, className: cn(BLOCK_NAME, (_b = {},
            _b["".concat(BLOCK_NAME, "--").concat(size)] = Boolean(size),
            _b["".concat(BLOCK_NAME, "--").concat(color)] = Boolean(color),
            _b["".concat(BLOCK_NAME, "--white-space-").concat(whiteSpace)] = Boolean(whiteSpace),
            _b["".concat(BLOCK_NAME, "--uppercase")] = isUpperCase,
            _b["".concat(BLOCK_NAME, "--ellipsis")] = isEllipsis,
            _b)), "data-name": "Text", title: title }, text));
};
/**
 * Компонент для отображения текста (цвет, шрифт, размер)
 */
export var Text = memo(TextComponent);
